import { ChangeDetectorRef, Component } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { from, Observable } from "rxjs";
import { BaseSearchFormFieldComponent } from "../base-search-form-field.component";
import { Driver, driverToString } from "src/services/driver/driver.interface";
import { DriverApiService } from "src/services/driver/driver-api.service";
import { isUser } from "src/services/user/user.interface";

@Component({
  selector: "rc-driver-form-field",
  templateUrl: "../base-search-form-field.component.html",
  styleUrls: ["../base-search-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DriverFormFieldComponent,
    },
  ],
  standalone: false,
})
export class DriverFormFieldComponent extends BaseSearchFormFieldComponent<Driver> {
  constructor(
    private readonly driverService: DriverApiService,
    cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  public toDisplayString(input: Driver | undefined): string {
    return driverToString(input);
  }

  protected getById(id: string): Observable<Driver | undefined> {
    return from(this.driverService.getByUserId(id));
  }

  protected getStorableValue(input: Driver): string {
    return input.userId;
  }

  protected getNoValueString(): string {
    return "No driver selected";
  }

  protected search(input: string): Observable<Driver[]> {
    return from(this.driverService.search(input));
  }

  public readonly isUser = isUser;
}
